import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { RecommendationCharacter } from '../../typings/recommendations';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './RecommendationIcon.css';

export interface RecommendationIconProps {
    theme: RecommendationCharacter;
    icon: Shape2Icon;
    cls?: string;
    title?: string;
}

export function RecommendationIcon({ theme, icon, title, cls }: RecommendationIconProps) {
    return (
        <div
            className={classNames(
                Bem.cls({
                    block: 'recommendation-icon',
                    mods: {
                        theme: theme
                    }
                }),
                cls
            )}
        >
            <Shape2 icon={icon} width={24} height={24} title={title} tone={Shape2Tone.white} />
        </div>
    );
}
